import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from './app.constants';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(private httpClient: HttpClient) { }

  get(): Observable<number> {
    return this.httpClient.get<number>(Constants.visitors);
  }

  post() {
    this.httpClient.post<number>(Constants.visitors, null).subscribe(x => { });
  }
}
